(() => {
  if (window.__dobsomCart) return;
  window.__dobsomCart = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECTIONS = 'cart-drawer,cart-icon-bubble';

  const post = (path, body) =>
    fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTIONS }, window.location.pathname.charAt(0) === '/' ? { sections_url: window.location.pathname } : {}, body)),
    }).then((r) => r.json());

  const render = (state) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !state || !state.sections) return;
    const parse = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    const inner = drawer.querySelector('.drawer__inner');
    const fresh = parse(state.sections['cart-drawer'], '.drawer__inner');
    if (inner && fresh) {
      inner.innerHTML = fresh.innerHTML;
      ['data-dcd-codes', 'data-dcd-err'].forEach((a) => inner.setAttribute(a, fresh.getAttribute(a) || ''));
    }
    drawer.classList.toggle('is-empty', state.item_count === 0);
    const bubble = document.getElementById('cart-icon-bubble');
    const freshBubble = state.sections['cart-icon-bubble'] && parse(state.sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
  };

  const currentCodes = () => {
    const inner = document.querySelector('cart-drawer .drawer__inner');
    return ((inner && inner.getAttribute('data-dcd-codes')) || '')
      .split(',')
      .map((c) => c.trim())
      .filter(Boolean);
  };

  const showCodeMsg = (text) => {
    const msg = document.querySelector('cart-drawer .dcd__code-msg');
    if (msg) msg.textContent = text || '';
  };

  // Lägg till förslag
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-dcd-add]');
    if (!btn) return;
    e.preventDefault();
    let id = btn.dataset.dcdAdd;
    if (!id) {
      const sel = btn.parentElement && btn.parentElement.querySelector('select[data-dcd-variant]');
      id = sel && sel.value;
      if (!id) {
        if (sel) { sel.classList.add('is-missing'); sel.focus(); }
        return;
      }
    }
    btn.setAttribute('aria-busy', 'true');
    try {
      await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      const state = await post('cart/update.js', {});
      render(state);
    } catch (err) {
      btn.removeAttribute('aria-busy');
    }
  });

  // Ta bort rabattkod
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-dcd-remove]');
    if (!btn) return;
    e.preventDefault();
    const remove = btn.dataset.dcdRemove.toLowerCase();
    const keep = currentCodes().filter((c) => c.toLowerCase() !== remove);
    btn.disabled = true;
    try {
      render(await post('cart/update.js', { discount: keep.join(',') }));
    } catch (err) {
      btn.disabled = false;
    }
  });

  // Vald storlek: ta bort röd markering
  document.addEventListener('change', (e) => {
    if (e.target.matches && e.target.matches('select[data-dcd-variant]')) e.target.classList.remove('is-missing');
  });

  // Använd rabattkod
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-dcd-code]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('input');
    const code = (input.value || '').trim();
    if (!code) return;
    const inner = document.querySelector('cart-drawer .drawer__inner');
    const errText = (inner && inner.getAttribute('data-dcd-err')) || '';
    const button = form.querySelector('button');
    button.setAttribute('aria-busy', 'true');
    showCodeMsg('');
    const codes = currentCodes().filter((c) => c.toLowerCase() !== code.toLowerCase());
    codes.push(code);
    try {
      const state = await post('cart/update.js', { discount: codes.join(',') });
      const found = (state.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      if (!found || !found.applicable) {
        const cleaned = await post('cart/update.js', {
          discount: (state.discount_codes || [])
            .filter((d) => d.applicable)
            .map((d) => d.code)
            .join(','),
        });
        render(cleaned);
        showCodeMsg(errText);
        const again = document.querySelector('cart-drawer [data-dcd-code] input');
        if (again) again.value = code;
      } else {
        render(state);
      }
    } catch (err) {
      showCodeMsg(errText);
      button.removeAttribute('aria-busy');
    }
  });
})();
